/**
 * @file Bridge通信常量定义文件
 * @description 定义了所有Bridge通信相关的常量
 */

// bridge返回interface定义
export interface BridgeResponse<T = unknown> {
  responseId: string
  result: {
    code: number
    data: T
    errorMsg?: string
  }
}

/**
 * Bridge方法名称常量
 * @description 定义了所有可用的Bridge方法名
 */
export const BRIDGE_METHODS = {
  /** 返回上一页或关闭页面 */
  GO_BACK: 'goBackOrFinish',
  /** 返回上一个页面 */
  ROUTER_POP: 'routerPop',
  /** 获取设备信息 */
  GET_DEVICE_INFO: 'getDeviceInfo',
  /** 支付功能 */
  PAY: 'pay',
  /** Toast提示 */
  SHOW_TOAST: 'showToast',
  /** 获取定位 */
  GET_LOCATION: 'getLocation',
  /** 弹窗获取定位 */
  REQUEST_LOCATION: 'requestLocation',
  /** 跳转登录页面 */
  LOGIN: 'login',
  /** 获取用户信息 */
  GET_USER_INFO: 'getUserInfo',
  /** 行程详情分享 */
  SHARE_TRIP: 'share',
  /** 行程详情分享截图保存 */
  SAVE_TRIP_IMAGE: 'save',
  /** 行程详情分享复制链接 */
  COPY_TRIP: 'paste',
  /** 拨号 */
  TEL: 'tel',
  /** 回到首页 */
  GO_HOME: 'goHome',
  /** 调起原生页面 */
  OPEN_PAGE: 'openPage',
  /** 获取系统状态栏高度 */
  GET_SYSTEM_BAR_HEIGHT: 'getSystemBarHeight',
  /** 埋点上报 */
  SEND_TRACK: 'analysis',
  /** 埋点上报-曝光浏览 */
  SEND_TRACK_INTERNAL: 'internalAnalysis',
  /** 上传视频 */
  UPLOAD_VIDEO: 'videoUpload',
  /** 上传图片视频并上传 */
  RESOURCE_PICK_AND_UPLOAD: 'resourcePickAndUpload',
  /** 多图片视频并上传 */
  MULTI_RESOURCE_PICK_AND_UPLOAD: 'multiResourcePickAndUpload',
  /** 查看视频详情 */
  VIDEO_DETAIL: 'toVideoDetail',
  /** 预览视频 */
  VIDEO_PREVIEW: 'VideoPreview',
  /** 上传发布视频内容 */
  VIDEO_UPLOAD_ARTICLE: 'videoUploadArticle',
  /** 获取发布状态 */
  GET_PUBLISH_STATUS: 'getVideoArticle',
  /** 上传视频结果提示 */
  GET_UPLOAD_SHOW: 'uploadVideoResTipShow',
  /** 图片选择 */
  IMAGE_PICKER: 'imagePicker',
  /** 设置系统状态栏样式 */
  SYSTEM_BAR_STYLE: 'systemBarStyle',
  /** 获取版本号 */
  GET_VERSION: 'getDeviceInfo',
  /** h5数据更新通知客户端 */
  SET_H5_RESULT: 'setH5Result',
  /** 页面渲染完成 */
  FIRST_CONTENTFUL_PAINT: 'firstContentfulPaint',
  /** 取消视频上传 */
  VIDEO_UPLOAD_CANCEL: 'videoUploadCancel',
  /** 实名认证 */
  REAL_NAME_CERTIFICATION: 'realNameCertification',
  /** 地图导航 */
  NAVIGATION: 'navigation',
  /** 启动外部App 火车票自购微信支付用 */
  LAUNCHURL: 'launchUrl'
} as const

export type BridgeMethodName = (typeof BRIDGE_METHODS)[keyof typeof BRIDGE_METHODS]

/**
 * Bridge通信处理器名称
 * @description Flutter和Web端通信的统一处理器名称
 */
export const BRIDGE_HANDLER = 'bridge'

/**
 * 生成回调ID
 * @param methodName - 方法名
 * @returns 格式为：cb_方法名_时间戳
 */
export const generateCallbackId = (methodName: string): string => {
  return `cb_${methodName}_${Date.now()}`
}
